import { useInfiniteQuery } from '@tanstack/react-query'
import { learnerProfileApi } from '@/api/learnerProfile'

export function useAttendanceHistory() {
  return useInfiniteQuery({
    queryKey: ['learner', 'me', 'attendance', 'history'],
    queryFn: async ({ pageParam }) => {
      const res = await learnerProfileApi.getAttendanceHistory({ cursor: pageParam, limit: 30 })
      return res.data.data
    },
    initialPageParam: null as string | null,
    getNextPageParam: (last) => last.nextCursor,
    staleTime: 30_000,
  })
}
